<template>
  <div class="hello">

    <menupicker value="registration">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>
    <div>
      <p><a href="https://s3-us-west-2.amazonaws.com/gmbch-forms/GrandMesaBackCountryHorsemen.pdf" target="_blank">Download our membership registration form</a> and our <a href="https://s3-us-west-2.amazonaws.com/gmbch-forms/GrandMesaBackCountryHorsemenLiabilityRelease.pdf" target="_blank"> liability release form</a>. Complete these and return with membership fee. </p>
      <p>You can also complete payment using the PayPal buttons below.</p>
    </div>

    <div class="paypal-button-row">
      <button
        v-for="btn in paypalButtons"
        :key="btn.id"
        class="paypal-button"
        @click="openPaypal(btn.paypalUrl)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 28" style="width:28px; height:28px; flex-shrink:0;" aria-hidden="true">
          <path d="M20.924 3.996C19.8 2.624 17.78 2 15.147 2H7.353a1.2 1.2 0 0 0-1.187 1.015L3.01 21.03a.72.72 0 0 0 .712.833h5.17l1.298-8.231-.04.258a1.2 1.2 0 0 1 1.185-1.015h2.47c4.845 0 8.636-1.968 9.746-7.659.033-.168.061-.332.085-.493-.14-.074-.14-.074 0 0 .33-2.098-.002-3.525-1.712-4.727z" fill="#003087"/>
          <path d="M10.194 8.68a1.048 1.048 0 0 1 1.038-.886h6.581c.78 0 1.507.051 2.17.158a9.2 9.2 0 0 1 1.327.332c.327.108.631.237.909.388.33-2.098-.001-3.524-1.712-4.676C18.874 2.624 16.854 2 14.22 2H6.427a1.2 1.2 0 0 0-1.187 1.015L2.083 21.03a.72.72 0 0 0 .712.833h5.17l1.298-8.231 .93-4.952z" fill="#003087"/>
          <path d="M22.219 9.49c-1.11 5.69-4.9 7.658-9.746 7.658h-2.47a1.2 1.2 0 0 0-1.186 1.015L7.15 26.18a.63.63 0 0 0 .623.72h4.373a1.05 1.05 0 0 0 1.038-.886l.043-.224.824-5.22.053-.287a1.05 1.05 0 0 1 1.037-.887h.654c4.23 0 7.538-1.718 8.505-6.686.403-2.073.195-3.804-.74-5.022a4.16 4.16 0 0 0-1.341-.967 7.4 7.4 0 0 1-.086.769z" fill="#009cde"/>
          <path d="M21.133 9.05a8 8 0 0 0-.494-.11 11 11 0 0 0-.833-.126c-.663-.107-1.39-.158-2.17-.158h-6.582a1.048 1.048 0 0 0-1.037.887l-1.4 8.874-.04.257a1.2 1.2 0 0 1 1.186-1.015h2.47c4.845 0 8.636-1.968 9.746-7.658.033-.168.06-.33.085-.493a6.3 6.3 0 0 0-.931-.458z" fill="#012169"/>
        </svg>
        <div>
          <div class="title">{{ btn.title }}{{ btn.amount ? ` ($${btn.amount})` : '' }}</div>
          <div class="subtitle">{{ btn.subtitle }}</div>
        </div>
      </button>
    </div>

  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import AWS from 'aws-sdk';
  import DynamoDb from 'aws-sdk/clients/dynamodb';
  import MenuPicker from './MenuPicker.vue';

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

export default {
  name: 'Registration',
  data () {
    return {
      active: 'registration',
      msg: 'Membership Registration Form',
      paypalButtons: [],
    }
  },
  methods: {
    openPaypal(url) {
      window.open(url, '_blank');
    },
    initCredentials() {
      return new AWS.CognitoIdentityCredentials({
        IdentityPoolId: localStorage.getItem('poolid'),
      }, { region: localStorage.getItem('region') });
    },
    loadData(awscredentials) {
      const docClient = new DynamoDb.DocumentClient({
        region: localStorage.getItem('region'),
        credentials: awscredentials,
      });
      return new Promise((resolve, reject) => {
        docClient.scan(
          { TableName: 'gmbch-membership-buttons' },
          (error, data) => {
            if (error) {
              console.error('dynamodb error: ' + error.message);
              reject(`dynamodb error: ${error.message}`);
            } else {
              resolve(data);
            }
          }
        );
      });
    },
    parseData(data) {
      this.paypalButtons = data.Items
        .slice()
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map(item => ({
          id: item.id,
          title: item.title,
          amount: item.amount || null,
          subtitle: item.subtitle,
          paypalUrl: item.paypalUrl,
        }));
    },
  },
  mounted() {
    this.loadData(this.initCredentials())
      .then(data => this.parseData(data));
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
  font-size: large;
}
ul .link {
  list-style-type: none;
  padding: 0;
}
li .link {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 75%;
    text-align: left;
  }

  .center {
    margin: auto;
    margin-top: 5px;
    width: 50%;
    padding: 10px;
  }

.green {
  border: 3px solid green;
}

.normalli {
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

.paypal-button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-bottom: 0;
}

.paypal-button {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 300px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px 18px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, background 0.15s;
  box-sizing: border-box;
}

.paypal-button:hover {
  background: #f9f9f9;
  border-color: #bbb;
}

.paypal-button:active {
  transform: scale(0.99);
}

.paypal-button .title {
  font-size: 15px;
  font-weight: 600;
  color: #111;
  margin-bottom: 3px;
}

.paypal-button .subtitle {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

</style>



// WEBPACK FOOTER //
// src/components/Registration.vue